export default __webpack_public_path__ + "static/speed-gauge-03-18ec5e363cbf58c3e2a73f6303086fa2.png";